<template>
	<v-container id="vacationsstatusoverview" fluid>
		<!-- >>> The Data Table -------------------------------------------- -->
		<v-data-table
			style="margin-bottom: 0px; margin-top: 0px;"
			:headers="headers"
			:items="get_VacationReport"
			:disable-pagination="true"
			:hide-default-footer="true"
			sort-by="fullName"

			item-key="id"
			class="elevation-1 data-table-custom-colors">

			<template v-slot:item.fullName="{ item }">
				<div style="display:flex;flex-direction:row;">
					<div style="display:flex;flex-direction:column;">
						<p style="font-weight:500; margin: 0;">{{ item.fullName }} - {{ item.resourceCode }}</p>
						<p style="font-weight:300; margin: 0; font-size: 13px;">
							 Base: {{ item.baseCode }}
						</p>
					</div>
				</div>
			</template>

			<template v-slot:item.fromDate="{ item }">
				<p style="font-weight:300; margin: 0;">{{ item.fromDate | dayjsUtcDe }}</p>
			</template>

			<template v-slot:item.toDate="{ item }">
				<p style="font-weight:300; margin: 0;">{{ item.toDate | dayjsUtcDe }}</p>
			</template>

			<template v-slot:item.type="{ item }">
				<v-chip style="color: #fff;" small color="rgb(254, 49, 234)" v-if="item.type === 'VACATION'">
					VACATION
				</v-chip>
				<v-chip style="color: #fff;" small color="rgb(255, 165, 0)" v-if="item.type === 'DAYOFF'">
					DAYOFF
				</v-chip>
				<v-chip style="color: #fff;" small color="rgb(69, 49, 254)" v-if="item.type === 'ILLNESS'">
					ILLNESS
				</v-chip>
				<v-chip style="color: #fff;" small color="rgb(229, 63, 44)" v-if="item.type === 'UNABLEFLIGHT'">
					UNABLEFLIGHT
				</v-chip>
			</template>

			<template v-slot:item.status="{ item }">
				<v-chip style="color: #ffffff;" label small color="#56A3A6" v-if="item.status === 'REQUESTED'">
					<v-icon left>mdi-label</v-icon>REQUESTED
				</v-chip>
				<v-chip style="color: #424242;" label small color="#FAE275" v-if="item.status === 'MAINREQUEST'">
					<v-icon left>mdi-label</v-icon>MAINREQUEST
				</v-chip>
				<v-chip style="color: #ffffff;" label small color="#458487" v-if="item.status === 'SECONDARYREQUEST'">
					<v-icon left>mdi-label</v-icon>SECONDARYREQUEST
				</v-chip>
				<v-chip style="color: #ffffff;" label small color="#315C5E" v-if="item.status === 'REPLACEMENTREQUEST'">
					<v-icon left>mdi-label</v-icon>REPLACEMENTREQUEST
				</v-chip>
				<v-chip style="color: #ffffff;" label small color="#29BF12" v-if="item.status === 'APPROVED'">
					<v-icon left>mdi-label</v-icon>APPROVED
				</v-chip>
				<v-chip style="color: #ffffff;" label small color="#F21B3F" v-if="item.status === 'REFUSED'">
					<v-icon left>mdi-label</v-icon>REFUSED
				</v-chip>
			</template>



			<!-- >>> Action:Column ----------------------------------------- -->
			<!-- <template v-slot:item.actions="{ item }">
				<span>
					<v-btn color="primary" fab x-small dark style="">
						<v-icon>mdi-calendar</v-icon>
					</v-btn>

					<v-btn color="primary" fab x-small dark style="">
						<v-icon>mdi-download</v-icon>
					</v-btn>

					<v-btn color="primary" fab x-small dark style="">
						<v-icon>mdi-layers</v-icon>
					</v-btn>

					<v-btn color="primary" fab x-small dark style="">
						<v-icon>mdi-delete</v-icon>
					</v-btn>
				</span>
			</template> -->

			<!-- >>> Expanded:Column --------------------------------------- -->
			<!-- <template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length">
					More info about: {{ item.fullName }}
				</td>
			</template> -->
		</v-data-table>
		<!-- <<< The Data Table -------------------------------------------- -->











	</v-container>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";


    export default {
        name: 'VacationsStatusOverviewHome',

		/* >>> *************************************************************** / /* Components */
		components: {

		}, // eo components{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>> Data Table Header ------------------
				headers : [
					{ text: 'Name', value: 'fullName', class: 'sticky-header grey lighten-3' },
					{ text: 'Pos.', value: 'position', align: 'center', class: 'sticky-header grey lighten-3' },
					{ text: 'From', value: 'fromDate', align: 'center', class: 'sticky-header grey lighten-3' },
					{ text: 'To', value: 'toDate', align: 'center', class: 'sticky-header grey lighten-3' },
					{ text: 'Type', value: 'type', align: 'center', class: 'sticky-header grey lighten-3' },
					{ text: 'Status', value: 'status', align: 'center', class: 'sticky-header grey lighten-3' },
					{ text: 'Days', value: 'days', align: 'center', class: 'sticky-header grey lighten-3' },
					// { text: 'Actions', value: 'actions', align: 'center', sortable: false, class: 'sticky-header grey lighten-3'},
					// { text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				],
				// >>> ------------------------------------
				// >>> ------------------------------------
				expanded: [],
				singleExpand: true,

			};

		}, // eo function data()
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
                'get_VacationReport'
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

        }, // eo watch{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Load both Departments.
        * Note:
		* Note: 1-3, Load Vacation Report.
        *
        */
		created: function() {

            let me = this,
                params = {
                    "baseCodes": null,
                    "fromDate": "2022-08-17T02:00:00+0200",
                    "idresources": null,
                    "positions": null,
                    "status": null,
                    "toDate": "2022-09-30T02:00:00+0200",
                    "types": null
                };


            me.$toc('>>> views/vacations/statusoverview/Home.vue >>> created');
			this.actn_call_getResourcesOfDepartment({ department: '12', secondLoad: false });
			this.actn_call_getResourcesOfDepartment({ department: '11', secondLoad: true });
            this.actn_call_load_AllEmployees({}); // all employees
			// >>> ------------------------------
			// this.actn_call_getVacationReport(params); // TODO: Only in Case of 'Member' ?

		}, // eo function created()
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_getResourcesOfDepartment',
				'actn_call_load_AllEmployees',
				// >>> --------------------------
                'actn_call_getVacationReport',
			]),


            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/









		} // eo methods{}
		/* <<< ****************************************************************/

    };
</script>

<style scoped>
	.v-data-table /deep/ .sticky-header {
		position: sticky;
		top: 65px;
		z-index: 1;
	}

	.v-data-table /deep/ .v-data-table__wrapper {
		margin-top: 0px;
		overflow: unset;
	}

	.v-data-table /deep/ tr:nth-child(2n) {
		background-color: #FAFAFA;
	}

	.v-chip__content {
		font-size: 12px;
	}

	.rowWasEdited {
		/* border-left: 4px solid #AB3B7C;
		padding-left: 4px; */
		/* background-color: #AB3B7C; */
		border: 2px solid #AB3B7C;
		padding: 2px;

	}
</style>

<style>
	.smaller-column {
		width: 5%;
	}

	.v-data-table /deep/ thead tr th {
		background-color: red !important;
	}

	.v-data-table table thead tr th {
		font-size: 15px;
	}


	.v-btn--fab.v-size--x-small {
		height: 24px;
		width: 24px;
	}

	.v-data-table table tbody tr td .v-btn {
		margin-right: 4px !important;
	}
</style>



// :single-expand="singleExpand"
// :expanded.sync="expanded"
// show-expand